import { IEventId, ICustomProperties } from "./Constants";
import { Environment } from "./../Constants";
import { App, Session, Host, Release } from "./Telemetry/Contracts";
import * as Utils from "./../Utils";
import ITelemetryLogger from "./Telemetry/ITelemetryLogger";
import TelemetryLoggerFactory from "./Telemetry/TelemetryLoggerFactory";

export { ICustomProperties, IEventId, EventIds } from "./Constants";

const NAMESPACE: string = "Office_Feedback";

let logger: ILogger;

/**
 * Initialize the logging module
 * @param environment environment
 * @param appName app name
 * @param appVersion app version
 * @param audienceGroup audience group
 * @param hostId host id
 * @param hostSessionId host session Id
 * @param hostVersion host version
 */
export function initialize(environment: Environment, appName: string, appVersion: string,
	audienceGroup: string, hostId: string, hostSessionId: string, hostVersion: string): void {
	logger = new Logger(
		TelemetryLoggerFactory.create(TokenManager.getTenantToken(environment),
			NAMESPACE,
			new App(appName, appVersion),
			new Session(Utils.guid()),
			new Host(hostId, hostSessionId, hostVersion),
			new Release(audienceGroup)));
}

/**
 * Get the logger object
 */
export function getLogger(): ILogger {
	return logger;
}

/**
 * Interface for a logger
 */
export interface ILogger {
	logEvent(eventId: IEventId, customProperties?: ICustomProperties): void;
}

/**
 * Class representing a logger for the feedback SDK
 */
export class Logger implements ILogger {
	private static EVENT_NAME: string = "SDK";
	private static EVENT_ID: string = "EventId";

	private telemetryLogger: ITelemetryLogger;

	constructor(telemetryLogger: ITelemetryLogger) {
		if (!telemetryLogger) {
			throw new Error("telemetryLogger must not be null");
		}

		this.telemetryLogger = telemetryLogger;
	}

	/**
	 * Log an event
	 * @param eventId event Id
	 * @param customProperties custom properties to add to the log
	 */
	public logEvent(eventId: IEventId, customProperties?: ICustomProperties) {
		if (!eventId) {
			throw new Error("eventId must not be null");
		}

		customProperties = customProperties || {};
		(<any> customProperties)[Logger.EVENT_ID] = eventId.name;

		this.telemetryLogger.logEvent(Logger.EVENT_NAME, customProperties);
	}
}

class TokenManager {
	public static getTenantToken(environment: Environment): string {
		if (environment === Environment.Production) {
			return TokenManager.TENANT_TOKEN_PRODUCTION;
		} else {
			return TokenManager.TENANT_TOKEN_PRE_PRODUCTION;
		}
	}

	private static TENANT_TOKEN_PRODUCTION: string =
	"d79e824386c4441cb8c1d4ae15690526-bd443309-5494-444a-aba9-0af9eef99f84-7360"; // "Office Feedback" Prod Aria tenant
	private static TENANT_TOKEN_PRE_PRODUCTION: string =
	"2bf6a2ffddca4a80a892a0b182132961-625cb102-8b0c-480e-af53-92e48695d08d-7736"; // "Office Feedback" Sandbox Aria tenant
}
